(function twainCaptureServiceModuleDefinition() {

    'use strict';

    angular.module("TwainCapture")
        .provider("twainCapture", ['configProvider',
            function (config) {

                var Dynamsoft = window.Dynamsoft || { WebTwainEnv: {} };

                var productKey = {twainKey: config.custom('twainKey') };
                var trial = true;
                var debug = false;
                var fileNameTemplate = 'Imagen Capturada $unique$';
                var available = true;

                /*
                 * Crea el elemento de instalación.
                 */
                var onCreateInstallElement = this.onCreateInstallElement = function (paramsObj) {

                    var ObjString = [
                            '<div class="dwt-box"><div class="dwt-box-title">{{ProductName}}',
                                ' no se encuentra instalado.</div>',
                                '<div style="margin:20px;text-align:center"><a id="dwt-btn-install" class="btn btn-primary" target="_blank" href="',
                                '{{InstallerUrl}}',
                                '" onclick="Dynamsoft_OnClickInstallButton()"><span class="glyphicon glyphicon-download-alt"></span>&nbsp;Descargar</a></br>',
                                '<i>* Por favor instalelo manualmente.</i></div>'];

                    if (paramsObj.bHTML5) {

                        if (paramsObj.bIE) {
                            ObjString.push('<div>');
                            ObjString.push('Si aún visualiza este mensaje luego de la instalación por favor<br />');
                            ObjString.push('1. <a href="http://windows.microsoft.com/en-us/windows/security-zones-adding-removing-websites#1TC=windows-7">agregue el sitio actual a la lista de Sitios de Confianza</a>.<br />');
                            ObjString.push('2. Refresque la página.');
                            ObjString.push('</div>');
                        } else {

                            if (paramsObj.bMac && paramsObj.bSafari && paramsObj.bSSL) {
                                ObjString.push('<div>');
                                ObjString.push('Luego de la instalación deberá dirigirse al siguiente<br />');
                                ObjString.push('<a href="http://kb.dynamsoft.com/questions/901">artículo</a> para habilitar el componente de escaneo en este sitio.');
                                ObjString.push('</div>');
                            }

                            ObjString.push('<div class="dwt-red" style="padding-top: 10px;">Luego de la instalación por favor refresque el navegador.</div>');
                        }

                    } else {
                        if (paramsObj.bIE) {
                            ObjString.push('<div>');
                            ObjString.push('Luego de la instalación, por favor<br />');
                            ObjString.push('1. Refresque el navegador.<br />');
                            ObjString.push('2. Permita que el componente "DynamicWebTWAIN" se ejecute realizando un click derecho en la barra de información del navegador.');
                            ObjString.push('</div>');
                        } else {
                            ObjString.push('<p class="dwt-red" style="padding-top: 10px;">Luego de la instalación, por favor refresque la página.</p>');
                        }
                    }
                    ObjString.push('</div>');

                    var elem = angular.element(ObjString.join(''));
                    elem.css({ width: '320px' });
                    return elem;
                }

                /*
                 * Crea el elemento de upgrade.
                 */
                var onCreateUpgradeElement = this.onCreateUpgradeElement = function (paramsObj) {

                    var ObjString = ['<div class="dwt-box"><div class="dwt-box-title"></div>',
                    '<div style="font-size: 15px;">',
                    'Esta aplicación utiliza una versión mas nueva del componente Dynamic Web TWAIN. Por favor instale la actualización.',
                    '</div>',
                    '<a id="dwt-btn-install" target="_blank" class="btn btn-primary" href="',
                    '{{InstallerUrl}}',
                    '" onclick="Dynamsoft_OnClickInstallButton()"><span class="glyphicon glyphicon-download-alt"></span>&nbsp;Descargar</a></br>',
                    '<div style="text-align:center"><i>* Por favor instalelo manualmente.</i></div><p></p>'];

                    if (paramsObj.bHTML5) {
                        ObjString.push('<div class="dwt-red">Por favor refresque su navegador luego de la actualización.</div>');
                    } else {

                        if (paramsObj.bIE) {
                            ObjString.push('<div class="dwt-red">');
                            ObjString.push('Por favor cierre el Internet Explorer antes de instalar la nueva versión.');
                            ObjString.push('</div>');
                        }
                        else {
                            ObjString.push('<div class="dwt-red">Por favor reinicie el navegador una vez realizada la actualización.</div>');
                        }
                    }
                    ObjString.push('</div>');

                    var elem = angular.element(ObjString.join(''));
                    elem.css({ width: '320px' });
                    return elem;
                }

                /*
                 * Crea el elemento de plugin bloqueado.
                 */
                var onCreateNotAllowedElement = this.onCreateNotAllowedElement = function (paramsObj) {

                    var ObjString = [
                    '<div class="dwt-box"><div class="dwt-box-title">',
                    'El componente {{ProductName}}',
                    ' no tiene permitida la ejecución en este sitio.</div>',
                    '<ul>',
                    '<li>Por favor seleccione "<b>Siempre permitir la ejecución en este sitio</b>" y luego refresque la página e intente nuevamente.</li>',
                    '</ul></div>'];

                    var elem = angular.element(ObjString.join(''));
                    elem.css({ width: '320px' });
                    return elem;
                };

                this.enableDebug = function () {
                    debug = true;
                };

                this.setKey = function (key) {
                    if (key) {
                        productKey.twainKey = key;
                        trial = false;
                    }
                };

                function setFileNameTemplate(template) {
                    if (template !== undefined) {
                        fileNameTemplate = template;
                    } else {
                        return fileNameTemplate;
                    }
                }

                this.setFileNameTemplate = setFileNameTemplate;

                Dynamsoft.WebTwainEnv.Containers = [];

                Dynamsoft.WebTwainEnv.AutoLoad = false;

                Dynamsoft.WebTwainEnv.ResourcesPath = config.resourceUrl('/components/twain-capture/dynamsoft-twain');

                var configLabels = {
                    title: 'Configuración',
                    yes: 'Si',
                    no: 'No',
                    ok: 'Aceptar',
                    cancel: 'Cancelar',
                    duplex: 'Ambos lados (duplex)',
                    autoDiscardBlankpages: 'Descartar páginas en blanco',
                    automaticBorderDetection: 'Detectar bordes',
                    resolution: 'Resolución (DPI)',
                    automaticDeskew: 'Orientar automáticamente',
                    pixelType: 'Tipo de Pixel',
                    source: 'Origen'
                };

                var configLabelsTranslator = ['$labels', function ($labels) {
                    return $labels;
                }];

                var defaultConfig = {
                    duplex: false,
                    autoDiscardBlankpages: true,
                    automaticBorderDetection: true,
                    resolution: 200,
                    automaticDeskew: false,
                    pixelType: EnumDWT_PixelType.TWPT_BW
                }

                this.configLabelsTranslator = function (func) {
                    configLabelsTranslator = func;
                };

                this.$get = ['$q', '$timeout', '$compile', '$injector', '$uibModal', 'config',
                    function ($q, $timeout, $compile, $injector, $modal, config) {

                        var dwObjectPromise = null,
                            dwObjectDeferred = null,
                            fileNameIndex = 0,
                            showUi = false;

                        Dynamsoft.WebTwainEnv.ProductKey = productKey.twainKey;

                        Dynamsoft.WebTwainEnv.Trial = trial;

                        Dynamsoft.WebTwainEnv.ActiveXInstallWithCAB = false;

                        Dynamsoft.WebTwainEnv.Debug = debug; // only for debugger output

                        var dwObject = null,
                            activeElementId = null,
                            activeElement = null;

                        Dynamsoft.WebTwainEnv.RegisterEvent('OnWebTwainReady', function () {

                            if (available) {
                                dwObject = Dynamsoft.WebTwainEnv.GetWebTwain(activeElementId);

                                //dwObject.Resolution = 200;
                                dwObject.Resolution = 300;

                                dwObjectDeferred.resolve();
                            } else {
                                dwObjectDeferred.reject();
                            }
                        });

                        /* 
                        Le agreggo a WebTwainEnv una función que desde el instalador 
                        me permitirá notificar cuando el plgin no esta disponible, etc.
                        */
                        var lastErrorParams = null,
                            lastErrorFunction = null;

                        var createfn = function (creationFn) {
                            return function (paramsObj) {
                                $timeout(function () { available = false; }, 100);
                                Dynamsoft.WebTwainEnv.Containers = [];
                                Dynamsoft.WebTwainEnv.Unload();

                                var childScope = activeElement.parent().scope().$new();

                                angular.extend(childScope, paramsObj);

                                $q.when(creationFn(paramsObj)).then(function (elem) {
                                    activeElement.replaceWith(elem);
                                    $compile(elem)(childScope);
                                });

                                lastErrorParams = paramsObj;
                                lastErrorFunction = creationFn;
                            }
                        };

                        Dynamsoft.WebTwainEnv.$$PluginNotAvailable = createfn(onCreateInstallElement);
                        Dynamsoft.WebTwainEnv.$$PluginNotAllowed = createfn(onCreateNotAllowedElement);
                        Dynamsoft.WebTwainEnv.$$MustUpgrade = createfn(onCreateUpgradeElement);
                        
                        var sliceSize = 1024;

                        /*
                         * Procesa un slice del base 64 y setea el proceso del siguiente con set timeout.
                         * NOTA: Esto es para mantener la pantalla lo mas responsiva posible.
                         * IMPROVEMENT: Quizas se podrían crear web workers para procesar los slices (hay que ver si la serialización vale la pena)
                         */
                        function processSlice(sliceIndex, byteArrays, byteCharacters, deferred, contentType) {

                            var blob = null;
                            var begin = sliceIndex * sliceSize;
                            var end = Math.min(begin + sliceSize, byteCharacters.length);
                            var slicesCount = byteArrays.length;

                            var bytes = new Array(end - begin);
                            for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
                                bytes[i] = byteCharacters[offset].charCodeAt(0);
                            }
                            byteArrays[sliceIndex] = new Uint8Array(bytes);

                            if (sliceIndex < slicesCount - 1) {
                                $timeout(function () {
                                    processSlice(sliceIndex + 1, byteArrays, byteCharacters, deferred, contentType);
                                });
                            } else {
                                try {
                                    blob = new Blob(byteArrays, { type: contentType });
                                }
                                catch (e) {
                                    // TypeError old chrome and FF
                                    window.BlobBuilder = window.BlobBuilder ||
                                                         window.WebKitBlobBuilder ||
                                                         window.MozBlobBuilder ||
                                                         window.MSBlobBuilder;
                                    if (e.name == 'TypeError' && window.BlobBuilder) {
                                        var bb = new BlobBuilder();
                                        bb.append(byteArrays);
                                        blob = bb.getBlob(contentType);
                                    }
                                    else if (e.name == "InvalidStateError") {
                                        // InvalidStateError (tested on FF13 WinXP)
                                        blob = new Blob(byteArrays, { type: contentType });
                                    }
                                    else {
                                        // We're screwed, blob constructor unsupported entirely  
                                    }
                                }
                                deferred.resolve(blob);
                            }
                        }

                        /*
                         * Setea el indice de los archivos. Si no se pasa argumento se resetea a 0.
                         */
                        function setFileNameStartIndex(num) {
                            fileNameIndex = num || 0;
                        }

                        /*
                         * Transforma un string base 64 a un blob.
                         */
                        function base64toBlob(base64Data, contentType) {

                            contentType = contentType || '';
                            var byteCharacters = atob(base64Data);
                            var byteArrays = new Array(Math.ceil(byteCharacters.length / sliceSize));

                            // IE11 No funciona bien cuando se chunkean los archivos.
                            if (window.MSBlobBuilder) {
                                var bytes = new Uint8Array(byteCharacters.length);
                                for (var i = 0; i < byteCharacters.length; i++) {
                                    bytes[i] = byteCharacters[i].charCodeAt(0);
                                }
                                return $q.when(new Blob([bytes], { type: contentType }));
                            }

                            var deferred = $q.defer();

                            processSlice(0, byteArrays, byteCharacters, deferred, contentType);

                            return deferred.promise;
                        }

                        /**
                         * Para no mostrar un "loading" en pantalla completa lo seteo dentro del parent del elemento.
                         */
                        function setEmbededLoading(element) {

                            var div = angular.element('<div class="twain-loading"></div>');
                            element.parent().append(div);

                            Dynamsoft.Lib.detect.OnWebTwainPreExecute = function () {
                                div.show();
                            };

                            Dynamsoft.Lib.detect.OnWebTwainPostExecute = function () {
                                div.hide();
                            };
                        }

                        /**
                         * Registra un contenedor de captura y carga el capture.
                         * @param {} element El elemento a registrar.
                         * @param {} width Ancho del elemento.
                         * @param {} height Alto del elemento.
                         * @returns {} 
                         */
                        function register(element, width, height) {

                            if (activeElement) {
                                unregister(activeElement);
                            }

                            // TODO: Calcular width y height en base al element si son null
                            activeElementId = element.prop('id');
                            activeElement = element;

                            Dynamsoft.WebTwainEnv.Containers = [{ ContainerId: activeElementId, Width: width || 270, Height: height || 350 }];

                            setEmbededLoading(element);

                            // El control queda mal seteado si ya se cargó una vez y se hizo un unload.
                            // Esta línea marca el evento bNoControlEvent como no ejecutado.
                            Dynamsoft.Lib.detect.bNoControlEvent = false;

                            Dynamsoft.WebTwainEnv.Load();

                            dwObject = null;
                            dwObjectDeferred = $q.defer();
                            dwObjectPromise = dwObjectDeferred.promise;
                        };

                        /**
                         * Desregistra el contenedor del capture.
                         * @param {} element 
                         * @returns {} 
                         */
                        function unregister(element) {

                            if (activeElementId && activeElementId == element.prop('id')) {

                                Dynamsoft.WebTwainEnv.Unload();

                                if (!dwObjectPromise) {
                                    throw "Debe inicializar el objeto de captura.";
                                }

                                dwObjectPromise.then(function () {
                                    Dynamsoft.WebTwainEnv.Containers = [];
                                    Dynamsoft.WebTwainEnv.Unload();
                                }, function () {
                                    Dynamsoft.WebTwainEnv.Containers = [];
                                    Dynamsoft.WebTwainEnv.Unload();
                                });

                                activeElement = null;
                                activeElementId = null;
                                dwObject = null;
                                dwObjectDeferred = null;
                            }
                        };

                        /**
                         * Muestra la UI de configuración y retorna una promesa que se resolverá cuando finalice la misma.
                         * @returns {} Una promesa que se resolverá cuando finalice la misma.
                         */
                        function showConfigUi() {

                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            var deferred = $q.defer();
                            
                            dwObjectPromise.then(function () {

                                function configLabelsTranslatorInvoker(val) {
                                    return $injector.invoke(configLabelsTranslator, this, { '$labels': val });
                                }

                                var configObject = {
                                    labels: configLabelsTranslatorInvoker(configLabels),
                                    values: angular.copy(defaultConfig)
                                };

                                var srcName = dwObject.CurrentSourceName || dwObject.DefaultSourceName;
                                var vCount = dwObject.SourceCount;
                                var oldSrc = -1;

                                if (configObject.values.source !== -1) {
                                    dwObject.SelectSourceByIndex(configObject.values.source);
                                }

                                for (var i = 0; i < vCount; i++) {
                                    if (dwObject.GetSourceNameItems(i) === srcName) {
                                        oldSrc = i;
                                        break;
                                    };
                                }

                                var modal = $modal.open({
                                    templateUrl: config.resourceUrl('/components/twain-capture/configuration-modal.html'),
                                    controller: ['configObject', '$scope', '$modalInstance',
                                        function modalController(configObject, $scope, $uibModalInstance) {
                                            $scope.config = configObject;

                                            $scope.resolutions = [100, 150, 200, 300];

                                            $scope.pixelTypes = [{ value: EnumDWT_PixelType.TWPT_BW, desc: configLabelsTranslatorInvoker('B&W') },
                                                                 { value: EnumDWT_PixelType.TWPT_GRAY, desc: configLabelsTranslatorInvoker('GrayScale') },
                                                                 { value: EnumDWT_PixelType.TWPT_RGB, desc: configLabelsTranslatorInvoker('Color') }];

                                            var vCount = dwObject.SourceCount;

                                            $scope.sources = [];

                                            for (var i = 0; i < vCount; i++) {
                                                $scope.sources.push({ name: dwObject.GetSourceNameItems(i), index: i });
                                            }

                                            var srcName = dwObject.CurrentSourceName || dwObject.DefaultSourceName;

                                            $scope.config.values.source = $scope.sources.findIndex(function (src) {
                                                return src.name === srcName;
                                            });

                                            $scope.sourceChanged = function () {
                                                dwObject.SelectSourceByIndex($scope.config.values.source);
                                                dwObject.OpenSource();

                                                $scope.supportsDuplex = (dwObject.Duplex !== EnumDWT_DUPLEX.TWDX_NONE);

                                                dwObject.CloseSource();
                                            };

                                            $scope.sourceChanged();

                                            $scope.ok = function () {
                                                $uibModalInstance.close(true);
                                            };

                                            $scope.cancel = function () {
                                                $uibModalInstance.close(false);
                                            };
                                        }
                                    ],
                                    backdrop: 'static',
                                    size: 'md',
                                    resolve: {
                                        configObject: function () {
                                            return configObject;
                                        }
                                    }
                                });

                                modal.result.then(function (result) {

                                    if (result) {
                                        if (oldSrc !== configObject.values.source) {
                                            if (dwObject.DataSourceStatus !== EnumDWT_DataSourceStatus.TWDSS_CLOSED) {
                                                dwObject.CloseSource();
                                            }

                                            dwObject.SelectSourceByIndex(configObject.values.source);
                                        }

                                        defaultConfig = configObject.values;
                                    } else {
                                        dwObject.SelectSourceByIndex(oldSrc);
                                    }

                                    deferred.resolve(configObject.values);
                                });

                            });

                            return deferred.promise;
                        };

                        /**
                         * Permite seleccionar el source.
                         * @returns {} 
                         */
                        function selectSource() {

                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            dwObjectPromise.then(function () {
                                dwObject.SelectSource();
                            });
                        };

                        /**
                         * Executa la funciona pasada como parámetro cuando se resuelva dwObjectPromise.
                         * La función se ejecuta pasando como primer parámetro una promesa que retornará este metodo.
                         * @param {} fun 
                         * @param {} params 
                         * @returns {} 
                         */
                        function exec(fun, params) {

                            var retPromise = $q.defer();

                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            dwObjectPromise.then(function () {
                                fun(retPromise, params);
                            });

                            return retPromise.promise;
                        };

                        function getValue(options, propertyName, defaultValue) {
                            return options[propertyName] === undefined ? defaultValue : options[propertyName];
                        }

                        function setupScan(retPromise, options) {

                            if (dwObject.DataSourceStatus !== EnumDWT_DataSourceStatus.TWDSS_CLOSED) {
                                dwObject.CloseSource();
                            }

                            if (defaultConfig.source
                                && dwObject.CurrentSourceName === '') {
                                dwObject.SelectSourceByIndex(defaultConfig.source);
                            }

                            dwObject.IfShowIndicator = getValue(options, 'showIndicator', false);

                            dwObject.SetOpenSourceTimeout(3000);

                            if (!dwObject.OpenSource() || dwObject.ErrorCode !== 0) {
                                retPromise.reject('ScannerError');
                                return false;
                            }

                            if (dwObject.IfUIControllable) {
                                dwObject.IfShowUI = getValue(options, 'showUi', false);
                            }

                            if (dwObject.Duplex !== EnumDWT_DUPLEX.TWDX_NONE) {
                                dwObject.IfDuplexEnabled = getValue(options, 'duplex', defaultConfig.duplex); //enable duplex
                            } else {
                                dwObject.IfDuplexEnable = false; // No reporta duplex pero lo soporta => lo deshabilito.
                            }

                            dwObject.IfDisableSourceAfterAcquire = true;
                            dwObject.IfFeederEnabled = getValue(options, 'enableFeeder', false);
                            dwObject.IfAutoDiscardBlankpages = getValue(options, 'autoDiscardBlankpages', defaultConfig.autoDiscardBlankpages);
                            dwObject.TransferMode = getValue(options, 'transferMode', 0);
                            dwObject.IfAutomaticBorderDetection = getValue(options, 'automaticBorderDetection', defaultConfig.automaticBorderDetection);

                            //dwObject.Resolution = getValue(options, 'resolution', defaultConfig.resolution);
                            dwObject.Resolution = 300;

                            dwObject.IfAutomaticDeskew = getValue(options, 'automaticDeskew', defaultConfig.automaticDeskew);
                            dwObject.PixelType = getValue(options, 'pixelType', defaultConfig.pixelType);

                            if (dwObject.IfFeederEnabled) {
                                /*
                                 * Muchos scanners no soportan el feeder en single page.
                                 */
                                dwObject.IfAllowLocalCache = true;  // habilito la cache local.
                                dwObject.IfAutoFeed = true;
                                dwObject.XferCount = -1;
                            }
                            return true;
                        }

                        /**
                         * Escanea una pagina
                         * @returns {} Una promesa que se resolverá con el indice de la imagen escaneada si termina ok.
                         */
                        function scanOne(options) {

                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            return exec(function (retPromise) {

                                if (dwObject.SourceCount === 0) {
                                    retPromise.reject('NoTwainSources');
                                    return;
                                }

                                var completedCallback = function () {
                                    dwObject.UnregisterEvent('OnPostTransfer', completedCallback);
                                    retPromise.resolve(dwObject.HowManyImagesInBuffer - 1);
                                };

                                // evento levantado cuando se transfiere una imagen.
                                dwObject.RegisterEvent('OnPostTransfer', completedCallback);

                                setupScan(retPromise, options || {});

                                dwObject.AcquireImage();
                            });
                        };

                        /**
                         * Comienza el escaneo utilizando el feeder en batches de a batchSize
                         * @param {} batchSize El tamaño del batch a obtener del feeder.
                         * @returns {} Una promesa que se resolvera si finalizó correctamente o arrojará error sino.
                         * Además cada vez que se transfiera una imagen se realizará un notify enviando el indice de la imagen como parámetro.
                         */
                        function scanBatched(batchSize, cancelDeferred, options) {

                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            options = angular.extend(options || {}, { enableFeeder: true });

                            return exec(function (retPromise) {

                                if (dwObject.SourceCount === 0) {
                                    retPromise.reject('NoTwainSources');
                                    return;
                                }

                                var counter = 0;

                                var singleCompletedCallback = function () {                                    
                                    if (++counter == batchSize) {
                                        $timeout((function (c) {
                                            return function () {
                                                retPromise.notify(c);
                                            }
                                        })(counter), 10); // uso esto en vez de un $apply
                                        counter = 0;
                                    }
                                };

                                var allCompletedCallback = function () {
                                    $timeout(function () {
                                        if (counter !== batchSize) {
                                            retPromise.notify(counter);
                                        }
                                        retPromise.resolve();
                                    }, 10); // uso esto en vez de un $apply
                                };

                                // evento levantado cuando se transfieren todas las imagenes.
                                dwObject.RegisterEvent('OnPostTransfer', singleCompletedCallback);
                                dwObject.RegisterEvent('OnPostAllTransfers', allCompletedCallback);
                                
                                setupScan(retPromise, options);

                                if (dwObject.IfFeederEnabled === true) {

                                    /*
                                     * Se hace el proceso sin el auto feed.
                                     */

                                    if (dwObject.IfFeederLoaded === true) {

                                        if (cancelDeferred) {
                                            cancelDeferred.promise.then(function () {
                                                dwObject.CancelAllPendingTransfers();
                                                retPromise.resolve();
                                            });
                                        }

                                        dwObject.AcquireImage();
                                    } else {
                                        retPromise.reject('FeederEmpty');
                                    }
                                } else {
                                    retPromise.reject('NoFeeder');
                                }
                            });
                        }

                        function feederLoaded() {
                            if (!dwObject) {
                                throw "No hay objeto de digitalización creado.";
                            }

                            if (defaultConfig.source 
                                && dwObject.CurrentSourceName === '') {
                                dwObject.SelectSourceByIndex(defaultConfig.source);
                            }

                            var isClosed = (dwObject.DataSourceStatus === EnumDWT_DataSourceStatus.TWDSS_CLOSED);

                            if (isClosed) {
                                dwObject.OpenSource();
                            }

                            var ret = dwObject.IfFeederLoaded;

                            if (isClosed) {
                                dwObject.CloseSource();
                            }

                            return ret;
                        }

                        /**
                         * Retorna la cantidad de imagenes que hay en el buffer.
                         */
                        function imagesCount() {
                            if (!dwObjectPromise || !dwObject) {
                                return 0;
                            }

                            return dwObject.HowManyImagesInBuffer;
                        }

                        /**
                         * Borra la imagen con el indice especificado.
                         */
                        function deleteImage(index) {
                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            return exec(function (retPromise) {
                                if (index < dwObject.HowManyImagesInBuffer) {
                                    dwObject.SelectedImagesCount = 0;
                                    var res = dwObject.RemoveImage(index);
                                    retPromise.resolve(res);
                                } else {
                                    retPromise.reject('BadIndex');
                                }
                            });
                        }

                        /**
                         * Remueve todas las imagenes escaneadas.
                         */
                        function clear() {
                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            return exec(function (retPromise) {
                                dwObject.DisableSource();
                                dwObject.CancelAllPendingTransfers();
                                dwObject.RemoveAllImages();
                                retPromise.resolve(true);
                            });
                        }

                        /**
                         * Retorna la primer imagen escaneada en un png base 64 y la remueve
                         */
                        function getImageBase64() {
                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            return exec(function (retPromise) {

                                if (dwObject.HowManyImagesInBuffer) {
                                    dwObject.SelectedImagesCount = 1;
                                    dwObject.SetSelectedImageIndex(0, 0);
                                    // NOTA: Si no se pide el size el to base 64 no retorna nada.
                                    dwObject.GetSelectedImagesSize(EnumDWT_ImageType.IT_PNG);

                                    var base64 = dwObject.SaveSelectedImagesToBase64Binary();

                                    retPromise.resolve(base64);
                                } else {
                                    retPromise.reject('NoImage');
                                }

                            });
                        }

                        /**
                         * Retorna la primer imagen escaneada en un blob que representa a un png
                         */
                        function getImageBlob() {
                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            return exec(function (retPromise) {

                                if (dwObject.HowManyImagesInBuffer) {
                                    dwObject.SelectedImagesCount = 1;
                                    dwObject.SetSelectedImageIndex(0, 0);

                                    // NOTA: Si no se pide el size el to base 64 no retorna nada.
                                    dwObject.GetSelectedImagesSize(EnumDWT_ImageType.IT_PNG);

                                    var base64 = dwObject.SaveSelectedImagesToBase64Binary();

                                    base64toBlob(base64, 'image/png').then(function (blob) {
                                        retPromise.resolve(blob);
                                    })
                                } else {
                                    retPromise.reject('NoImage');
                                }
                            });
                        }

                        /**
                         * Retorna la primer imagen escaneada en un File (png) con el name especificado.
                         */
                        function getImageFile(index, fileName) {
                            return getImageBlob(0).then(function (blob) {

                                var name = (fileName || fileNameTemplate || 'file $unique$').replace('$unique$', fileNameIndex++) + '.png';

                                try {
                                    return new File([blob], name, { type: 'image/png' });
                                } catch (e) {
                                    blob.lastModifiedDate = new Date();
                                    blob.name = name;
                                    return blob;
                                }
                            });
                        }

                        /**
                         * Retorna la primer imagen escaneada en un png base 64 y la remueve
                         */
                        function popImageBase64() {
                            return getImageBase64(0).then(function (ret) {
                                deleteFirstImage();
                                return ret;
                            });
                        }

                        /**
                         * Retorna la primer imagen escaneada en un blob que representa a un png
                         */
                        function popImageBlob() {
                            return getImageBlob(0).then(function (ret) {
                                deleteFirstImage();
                                return ret;
                            });
                        }

                        /**
                         * Retorna la primer imagen escaneada en un file png.
                         * Si se especifica fileName se utilizará dicho nombre, reemplazando $unique$ 
                         * por un número. Si no se especifica se utilizará el template file name.
                         */
                        function popImageFile(fileName) {
                            return getImageFile(0, fileName).then(function (ret) {
                                deleteFirstImage();
                                return ret;
                            });
                        }

                        /**
                         * Remueve la primer imagen del buffer.
                         */
                        function deleteFirstImage() {
                            return deleteImage(0);
                        }

                        function setShowUi(enabled) {
                            showUi = enabled;
                        }

                        /*
                         * Retorna la cantidad de origenes TWAIN del sistema
                         */
                        function sourcesCount() {

                            if (!dwObjectPromise) {
                                throw "Debe inicializar el objeto de captura.";
                            }

                            return exec(function (retPromise) {
                                retPromise.resolve(dwObject.sourcesCount);
                            });
                        }

                        /*
                         * Lee los barcodes de la imagen con el infice especificado.
                         * Se retornará una promesa conteniendo un array con los siguientes objetos:
                         * {content: "", type: svc.BarcodeTypes}
                         * El parámetro options permite pasar un objeto con las siguientes opciones:
                         * {
                         *      type: null | svc.BarcodeTypes -> Tipos de barcode a leer.
                         *      length: null | <number> -> Longitud del barcode.
                         *      prefix: null | <string> -> prefijo que deberá tener el barcode.
                         * }
                         */
                        function readBarcodes(index, options) {

                            options = options || {};

                            var deferred = $q.defer();

                            if (dwObject) {

                                function BarcodeError(errorCode, errorString) {
                                    deferred.reject({
                                        errorCode: errorCode,
                                        errorString: errorString
                                    });
                                }

                                dwObject.Addon.Barcode.Download(config.resourceUrl("components/twain-capture/dynamsoft-twain/addon/Barcode.zip"),
                                    function () {

                                        function BarcodesRead(imageIndex, result) {

                                            var count = result.GetCount();
                                            var barcodes = [];

                                            for (var i = 0; i < count; i++) {

                                                var text = result.GetContent(i);
                                                var format = result.GetFormat(i);

                                                if (options.length && options.length !== -1 && text.length !== options.length) {
                                                    continue;
                                                }

                                                if (options.prefix && text.indexOf(options.prefix) !== 0) {
                                                    continue;
                                                }

                                                barcodes.push({
                                                    content: text,
                                                    type: format
                                                });
                                            }

                                            deferred.resolve(barcodes);
                                        }

                                        dwObject.Addon.Barcode.Read(index, options.type || EnumDWT_BarcodeFormat.All, BarcodesRead, BarcodeError);
                                    },
                                    BarcodeError);
                            }

                            return deferred.promise;
                        }

                        function escapeRegExp(str) {
                            return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
                        }

                        /*
                         * Genera un nombre y se asegura que sea único en el array. Si no se especifica getter se asume que los elementos son file y tienen "name".
                         */
                        function findUniqueName(array, fileName, getter, minIndex) {

                            fileName = escapeRegExp(fileName || fileNameTemplate || 'file $unique$');

                            if (fileName.indexOf('\\$unique\\$') === -1) {
                                fileName = fileName + '\\$unique\\$';
                            }
                            
                            var regex = new RegExp('^' + fileName.replace('\\$unique\\$', '(\\d+)') + '\.png$', 'i');

                            minIndex = minIndex || fileNameIndex;

                            angular.forEach(array, function (itm) {

                                var name = getter ? getter(itm) : itm.name;

                                var matches = regex.exec(name);

                                if (matches) {
                                    
                                    var index = parseInt(matches[1]);
                                    if (index >= minIndex) {
                                        minIndex = index + 1;
                                    }
                                }
                            });

                            fileNameIndex = minIndex;

                            return fileName.replace('\\$unique\\$', minIndex);
                        }

                        /*
                        Devuelve si el escanner esta en escala de grises o no.
                        */
                        function isGrayScale(){
                            if (defaultConfig) {
                                return (defaultConfig.pixelType == EnumDWT_PixelType.TWPT_GRAY)
                            } else {
                                return false;
                            }
                        }

                        return {
                            register: register,
                            unregister: unregister,
                            showConfigUi: showConfigUi,
                            selectSource: selectSource,
                            scanOne: scanOne,
                            scanBatched: scanBatched,
                            popImageBase64: popImageBase64,
                            popImageBlob: popImageBlob,
                            popImageFile: popImageFile,
                            deleteFirstImage: deleteFirstImage,
                            imagesCount: imagesCount,
                            deleteImage: deleteImage,
                            getImageBase64: getImageBase64,
                            getImageBlob: getImageBlob,
                            getImageFile: getImageFile,
                            isAvailable: function () {
                                return available;
                            },
                            setShowUi: setShowUi,
                            feederLoaded: feederLoaded,
                            sourcesCount: sourcesCount,
                            readBarcodes: readBarcodes,
                            /*
                                All: 183806,
                                OneD: 180702,
                                CODABAR: 2,
                                CODE_39: 4,
                                CODE_93: 8,
                                CODE_128: 16,
                                DATAMATRIX: 32,
                                EAN_8: 64,
                                EAN_13: 128,
                                ITF: 256,
                                PDF417: 1024,
                                QR_CODE: 2048,
                                UPC_A: 16384,
                                UPC_E: 32768,
                                INDUSTRIAL_25: 131072                                
                             */
                            BarcodeTypes: EnumDWT_BarcodeFormat,
                            clear: clear,
                            setFileNameStartIndex: setFileNameStartIndex,
                            fileNameTemplate: setFileNameTemplate,
                            findUniqueName: findUniqueName,
                            isGrayScale: isGrayScale
                        };
                    }];
            }
        ]);

})();
